import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MarkdownComponent } from './markdown.component';

@NgModule({
    imports: [CommonModule],
    exports: [MarkdownComponent],
    declarations: [MarkdownComponent]
})
export class MarkdownModule {}
